import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PRODUCERS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createProducerAction = createAsyncThunk(
    'product/createProducerAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(`${ PRODUCERS_PATH }`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createProducerSlice = createSlice({
    name: 'createProducerSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createProducerAction.pending, () => STATE__API__STARTED);
        builder.addCase(createProducerAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createProducerAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createProducerState = (state) => state.product.createProducer;
export default createProducerSlice.reducer;
